<template>
	<!-- 采购人员信息上传组件 -->
	<el-row>
		<el-col :span="24">
			<el-form ref="personnel" :model="personnel" :rules="rules" label-width="90px" size="small">
				<!-- title -->
				<div class="flex-prompt">
					采购人员信息
					<span class="msg" :style="{ color: staleDay.type === 'Expired' ? '#FF3939' : '#E47D2F' }">{{ staleDay.state + staleDay.day }}</span>
				</div>
				<el-form-item prop="type" class="text-left">
					<div>
						<el-radio v-model="personnel.type" label="1" :disabled="operationState > 2" @change="typeChange">
							法人或负责人
							<span class="remind">(采购人员姓名在证照上)</span>
						</el-radio>
					</div>
					<div>
						<el-radio v-model="personnel.type" label="2" :disabled="operationState > 2" @change="typeChange">
							委托人
							<span class="remind">(采购人员姓名不在证照)</span>
						</el-radio>
					</div>
				</el-form-item>
				<el-form-item prop="positive" class="text-left last">
					<el-row>
						<el-col :span="6">
							<!-- 新增，编辑权限 -->
							<div v-show="operationState !== 3">
								<!-- 图片上传 (证件照正面) -->
								<el-upload
									:class="{ hide: limitPositiveCount > 0, positiveBox: limitPositiveCount === 0 }"
									ref="positiveUpload"
									action=""
									accept=".jpg,.png,.jpeg"
									:auto-upload="true"
									:limit="1"
									list-type="picture-card"
									:http-request="handlePositiveUploadRequest"
									:on-preview="handlePictureCardPreview"
									:on-remove="handlePositiveRemove"
									:before-upload="beforeAvatarUpload"
									:file-list="positiveFileList"
									:on-change="positiveChange"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
								<span class="remind">身份证人像面</span>
							</div>
							<!-- 查看权限 -->
							<div v-show="operationState === 3">
								<ul class="flex-palace">
									<li>
										<el-image
											@click="handlePictureCardPreview('https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg')"
											style="width: 160px; height: 94px"
											src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
											fit="cover"
										></el-image>
									</li>
								</ul>
							</div>
						</el-col>
						<el-col :span="6">
							<!-- 新增，编辑权限 -->
							<div v-show="operationState !== 3">
								<!-- 图片上传 (证件照反面) -->
								<el-upload
									:class="{ reverseshide: limitReverseCount > 0, reversesBox: limitReverseCount === 0 }"
									ref="reversesUpload"
									action=""
									accept=".jpg,.png,.jpeg"
									:auto-upload="true"
									:limit="1"
									list-type="picture-card"
									:http-request="handleReverseUploadRequest"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleReverseRemove"
									:before-upload="beforeAvatarUpload"
									:file-list="reversesFileList"
									:on-change="reversesChange"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
								<span class="remind">身份证国徽面</span>
							</div>
							<!-- 查看权限 -->
							<div v-show="operationState === 3">
								<ul class="flex-palace">
									<li>
										<el-image
											@click="handlePictureCardPreview('https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg')"
											style="width: 160px; height: 94px"
											src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
											fit="cover"
										></el-image>
									</li>
								</ul>
							</div>
						</el-col>
						<el-col :span="6" v-show="personnel.type === '2'">
							<!-- 新增，编辑权限 -->
							<div v-show="operationState !== 3">
								<!-- 图片上传 (证件照反面) -->
								<el-upload
									:class="{ entrusthide: limitEntrustCount > 0, entrustBox: limitEntrustCount === 0 }"
									ref="entrustUpload"
									action=""
									accept=".jpg,.png,.jpeg"
									:auto-upload="true"
									:limit="1"
									list-type="picture-card"
									:http-request="handleEntrustUploadRequest"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleEntrustRemove"
									:before-upload="beforeAvatarUpload"
									:file-list="entrustFileList"
									:on-change="entrustChange"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
								<span class="remind">委托书</span>
							</div>
							<!-- 查看权限 -->
							<div v-show="operationState === 3">
								<ul class="flex-palace">
									<li>
										<el-image
											@click="handlePictureCardPreview('https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg')"
											style="width: 160px; height: 94px"
											src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
											fit="cover"
										></el-image>
									</li>
								</ul>
							</div>
						</el-col>
						<el-col :span="6" v-show="personnel.type === '2'">
							<el-button type="text" icon="el-icon-download" @click="download(2)" style="padding-top: 80px;">下载委托书模版</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item label="姓名:" prop="PersonName" class="text-left">
					<el-input
						style="width: 280px;"
						v-model="personnel.PersonName"
						clearable
						maxlength="10"
						:disabled="operationState > 2"
						placeholder="请输入姓名"
					></el-input>
				</el-form-item>
				<el-form-item label="身份证号:" prop="IdCode" class="text-left">
					<el-input
						style="width: 280px;"
						v-model="personnel.IdCode"
						clearable
						maxlength="18"
						:disabled="operationState > 2"
						placeholder="请输入身份证号"
					></el-input>
				</el-form-item>
				<!-- 大图预览弹窗 -->
				<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
			</el-form>
		</el-col>
	</el-row>
</template>

<script>
import {oss,bucketConfig} from '@/utils/oss';

export default {
	props: {
		initPersonnelData: {
			type: Object,
			default: () => {}
		},
		// 有效期对象
		personnelStaleDay: {
			type: Object,
			default: () => ''
		}
	},
	data() {
		return {
			// 提交表单数据
			personnel: {
				Name: '采购人员', //名称
				type: '1', //类型 1法人或负责人 2委托人
				IdCode: '',
				PersonName: '',
				ImgList: [] //提交图片对象
			},
			// 有效期
			staleDay: {
				state: '',
				day: '',
				type: ''
			},
			// 正面照片上传按钮显示切换 图片长度
			limitPositiveCount: 0,
			// 反面照片上传按钮显示切换 图片长度
			limitReverseCount: 0,
			// 委托书上传按钮显示切换 图片长度
			limitEntrustCount: 0,
			// 大图预览url
			dialogImageUrl: '',
			// 大图预览弹窗
			dialogVisible: false,
			// 表单基础数据验证规则
			rules: {
				positive: [{ required: true, message: '请上证件照正面', trigger: 'blur' }],
				reverses: [{ required: true, message: '请上证件照反面', trigger: 'blur' }],
				PersonName: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
				IdCode: [
					{ required: true, message: '请填写身份证号', trigger: 'blur' },
					{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号码输入不正确', trigger: 'blur' }
				],
				entrust: [{ required: true, message: '请上委托书', trigger: 'blur' }]
			},
			// 页面操作状态 1新增，2编辑，3查看
			operationState: 1,
			// 上传文件集合（证件照正面）
			positiveFileList: [],
			// 上传文件集合（证件照反面）
			reversesFileList: [],
			// 上传文件集合（委托书）
			entrustFileList: []
		};
	},
	watch: {
		// 监听参数变化，区分新增和编辑，查看状态
		initPersonnelData: {
			handler(newData, oldData) {
				if (newData.initPersonnelData === undefined) {
					return;
				}
				// 渲染数据
				this.updateData(newData);
			},
			deep: true,
			immediate: false
		},
		// 监听参数变化
		personnelStaleDay: {
			handler(newData, oldData) {
				if (newData.personnelStaleDay === undefined) {
					return;
				}
				let staleDay = JSON.parse(newData.personnelStaleDay);
				if (staleDay && staleDay.Type && staleDay.Type !== null) {
					if (staleDay.Type === 'Warning') {
						// 将要过期
						this.staleDay = {
							state: '(将要过期,剩',
							day: staleDay.StaleDay + '天)',
							type: staleDay.Type
						};
					}
					if (staleDay.Type === 'Expired') {
						// 过期
						this.staleDay = {
							state: '(已过期',
							day: staleDay.StaleDay + '天)',
							type: staleDay.Type
						};
					}
				}
			},
			deep: false,
			immediate: false
		}
	},
	mounted() {},
	methods: {
		/*
		 * 渲染数据
		 */
		updateData(data) {
			let obj = JSON.parse(data.initPersonnelData);
			// 设置页面操作状态
			this.operationState = obj.operationState;
			// 名称
			this.personnel.Name = obj.PersonZzInfo.Name;
			this.personnel.PersonName = obj.PersonZzInfo.PersonName;
			this.personnel.IdCode = obj.PersonZzInfo.IdCode;
			// 是否法人
			this.personnel.type = obj.PersonZzInfo.IsLegalPerson ? '1' : '2';
			// 图片
			if (obj.PersonZzInfo.ImgList.length !== 0) {
				obj.PersonZzInfo.ImgList.forEach(item => {
					// 追加到待提交对象中
					this.personnel.ImgList.push({
						Url: item.Url, //图片地址
						Type: item.Type //类型（1:身份证正面、2:身份证反面、3:委托书）
					});
					if (item.Type === 1 && item.Url !== null) {
						// 展示默认值
						this.positiveFileList.push({
							url: item.Url //图片地址
						});
						// 自定义计数器
						this.limitPositiveCount++;
					} else if (item.Type === 2 && item.Url !== null) {
						// 证件照反面
						// 展示默认值
						this.reversesFileList.push({
							url: item.Url === null ? '' : item.Url //图片地址
						});
						// 自定义计数器
						this.limitReverseCount++;
					} else if (item.Type === 3 && item.Url !== null) {
						// 委托书
						// 展示默认值
						this.entrustFileList.push({
							url: item.Url === null ? '' : item.Url //图片地址
						});
						// 自定义计数器
						this.limitEntrustCount++;
					}
				});
			}
		},
		/*
		 * 类型切换
		 */
		typeChange(e) {
			e === '1' ? (this.personnel.type = '1') : (this.personnel.type = '2');
		},
		/*
		 * 下载模板
		 * @param {type} 类型 1gps模板 2委托书模板
		 */
		download(type) {
			let url = '';
			type === 1 ? (url = 'https://yyyupdate.oss-cn-shanghai.aliyuncs.com/Template/gsp.doc') : (url = `https://yyyupdate.oss-cn-shanghai.aliyuncs.com/Template/wts.doc`);
			window.open(url);
		},
		/*
		 * 文件上传按钮显示切换（证件照正面）
		 */
		positiveChange(file, fileList) {
			this.limitPositiveCount = fileList.length;
		},
		/*
		 * 上传成功监听（证件照正面）
		 */
		async handlePositiveUploadRequest(file) {
			let url = await oss(this.getAction.bind(this), file, bucketConfig['hys-cualifications'], window.localStorage.getItem('UserId'));
			this.personnel.ImgList.push({
				Url: url, //图片地址
				Type: 1 //类型（1:身份证正面、2:身份证反面、3:委托书）
			});
		},
		/*
		 * 图片删除（证件照正面）
		 */
		handlePositiveRemove(file, fileList) {
			let url = '';
			if (typeof file.response === 'undefined') {
				url = file.url;
			} else {
				url = file.response.Data;
			}
			this.limitPositiveCount = fileList.length;
			this.deleteArr(url);
		},
		/*
		 * 文件上传按钮显示切换（证件照反面）
		 */
		reversesChange(file, fileList) {
			this.limitReverseCount = fileList.length;
		},
		/*
		 * 上传成功监听（证件照反面）
		 */
		async handleReverseUploadRequest(file) {
			let url = await oss(this.getAction.bind(this), file, bucketConfig['hys-cualifications'], window.localStorage.getItem('UserId'));
			this.personnel.ImgList.push({
				Url: url, //图片地址
				Type: 2 //类型（1:身份证正面、2:身份证反面、3:委托书）
			});
		},
		/*
		 * 图片删除（证件照反面）
		 */
		handleReverseRemove(file, fileList) {
			let url = '';
			if (typeof file.response === 'undefined') {
				url = file.url;
			} else {
				url = file.response.Data;
			}
			this.limitReverseCount = fileList.length;
			this.deleteArr(url);
		},
		/*
		 * 文件上传按钮显示切换（委托书）
		 */
		entrustChange(file, fileList) {
			this.limitEntrustCount = fileList.length;
		},
		/*
		 * 上传成功监听（委托书）
		 */
		handleEntrustSuccess(response, file, fileList) {
			// 追加到待提交对象中
			this.personnel.ImgList.push({
				Url: response.Data, //图片地址
				Type: 3 //类型（1:身份证正面、2:身份证反面、3:委托书）
			});
		},
		async handleEntrustUploadRequest(file) {
			let url = await oss(this.getAction.bind(this), file);
			this.license.ImgList.push(url);
			this.personnel.ImgList.push({
				Url: url, //图片地址
				Type: 3 //类型（1:身份证正面、2:身份证反面、3:委托书）
			});
		},
		/*
		 * 图片删除（委托书）
		 */
		handleEntrustRemove(file, fileList) {
			let url = '';
			if (typeof file.response === 'undefined') {
				url = file.url;
			} else {
				url = file.response.Data;
			}
			this.limitEntrustCount = fileList.length;
			this.deleteArr(url);
		},
		/*
		 * 匹配并删除本地待提交的图片对象
		 */
		deleteArr(url) {
			// 删除待提交对象中对应图片
			this.personnel.ImgList.forEach((value, index, array) => {
				if (value.Url === url) {
					array.splice(index, 1);
				}
			});
		},
		/*
		 * 图片预览
		 */
		handlePictureCardPreview(file) {
			this.operationState !== 3 ? (this.dialogImageUrl = file.url) : (this.dialogImageUrl = file);
			this.dialogVisible = true;
		},
		/*
		 * 图片上传限制
		 */
		beforeAvatarUpload(file) {
			const isLt5M = file.size / 1024 / 1024 < 3;
			if (!isLt5M) {
				this.$message.error('上传图片大小不能超过 3MB!');
			}
			return isLt5M;
		}
	}
};
</script>

<style lang="less" scoped>
/deep/.msg {
	color: #ff3939;
	font-size: 10px;
	padding: 0 5px;
}
/deep/.el-upload--picture-card {
	width: 160px !important;
	height: 94px !important;
	line-height: 100px !important;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
	width: 160px !important;
	height: 94px !important;
}
/deep/.flex-palace {
	display: flex;
	margin: 0;
	/deep/li {
		flex: 0 0 160px;
		height: 94px;
		margin: 0 10px 0 0;
		/deep/img {
			border-radius: 4px;
		}
	}
}
/deep/.remind {
	font-size: 10px;
	color: #777777;
}
/deep/.positiveBox .el-upload--picture-card {
	background-image: url(../../../../assets/myQualifications/icon1.png);
	background-size: cover;
}
.hide {
	height: auto;
	/deep/.el-upload--picture-card {
		display: none;
		background-color: #fbfdff !important;
	}
}
/deep/.reversesBox .el-upload--picture-card {
	background-image: url(../../../../assets/myQualifications/icon2.png);
	background-size: cover;
}
.reverseshide {
	height: auto;
	/deep/.el-upload--picture-card {
		display: none;
		background-color: #fbfdff !important;
	}
}
/deep/.entrustBox .el-upload--picture-card {
	background-color: #e6f1ff;
}
.entrusthide {
	height: 95px;
	/deep/.el-upload--picture-card {
		display: none;
		background-color: #fbfdff !important;
	}
}
/deep/.el-upload-list__item {
	transition: none;
}
</style>
